module.exports = __webpack_public_path__ + "static/img/bg-9.84eabb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-9.png
// module id = K997
// module chunks = 0